function cleanupPrebuiltSlickDOM() {
  const sliderSelectors = [
    ".ltn__slide-one-active",
    ".ltn__search-by-place-slider-1-active",
    ".ltn__product-slider-item-three-active",
    ".ltn__testimonial-slider-4-active:not(.qtech-home-testimonial-slider):not(.qtech-about-testimonial-slider)",
  ];

  sliderSelectors.forEach((selector) => {
    const sliders = document.querySelectorAll(selector);
    sliders.forEach((slider) => {
      const track = slider.querySelector(":scope > .slick-list > .slick-track");
      if (track) {
        const seen = new Set();
        const cleanSlides = [];
        Array.from(track.children).forEach((slide) => {
          const rawIndex = slide.getAttribute("data-slick-index");
          const index = Number(rawIndex);
          if (!Number.isFinite(index) || index < 0 || seen.has(index)) return;
          seen.add(index);
          cleanSlides.push(slide);
        });
        slider.innerHTML = "";
        cleanSlides.forEach((slide) => slider.appendChild(slide));
      }

      slider.querySelectorAll(":scope > .slick-arrow, :scope > .slick-dots").forEach((node) => node.remove());
      slider.classList.remove("slick-slider", "slick-initialized", "slick-dotted");
      slider.removeAttribute("role");

      slider.querySelectorAll("[data-slick-index],[aria-describedby],[aria-hidden],[tabindex],[id]").forEach((node) => {
        if (node.classList?.contains("slick-slide")) {
          node.classList.remove("slick-slide", "slick-active", "slick-current", "slick-center", "slick-cloned");
        }
        node.removeAttribute("data-slick-index");
        node.removeAttribute("aria-describedby");
        node.removeAttribute("aria-hidden");
        node.removeAttribute("tabindex");
        if (node.id && node.id.startsWith("slick-")) node.removeAttribute("id");
      });
    });
  });
}

export function cleanupThemeDomBeforeReactUpdate() {
  const $ = window.jQuery || window.$;

  if ($ && typeof $.fn?.slick === "function") {
      document
      .querySelectorAll(
        ".slick-initialized:not(.qtech-hero-slider):not(.qtech-featured-slider):not(.qtech-location-slider):not(.qtech-home-testimonial-slider):not(.qtech-about-testimonial-slider)"
      )
      .forEach((node) => {
      try {
        $(node).slick("unslick");
      } catch {
        /* ignore stale slick teardown issues */
      }
    });
  }

  cleanupPrebuiltSlickDOM();
}
